import gql from 'graphql-tag';

export default gql`
  query cartGetNextDeliveryDate($supplierId: Int!) {
    cartGetNextDeliveryDate(supplierId: $supplierId)
  }
`;
